'use client'

import { CookiesProvider } from 'react-cookie'
import type * as React from 'react'

export function AppCookiesProvider({ children }: { children: React.ReactNode }) {
  return <CookiesProvider>{children}</CookiesProvider>
}
